"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUniqueId = useUniqueId;
exports.default = void 0;

var _react = require("react");

var _gmOptsContext = _interopRequireDefault(require("./gmOptsContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useUniqueId() {
  const idRef = (0, _react.useRef)(null);

  if (idRef.current === null) {
    idRef.current = Math.random();
  }

  return idRef.current;
}
/**
 * React hook for accepting global markup options objects and sending them to a context provider to be merged together
 * @param {object} gmOptions - global markup options object
 */


const useGlobalMarkupOptions = gmOptions => {
  const id = useUniqueId();
  const context = (0, _react.useContext)(_gmOptsContext.default) || {};

  const emitChange = () => {
    const {
      setGMOptions
    } = context;
    if (!setGMOptions) return;
    setGMOptions(id, gmOptions);
  };

  (0, _react.useEffect)(() => () => {
    // componentWillUnmount
    const {
      GlobalMarkupOptionsInstances
    } = context;
    if (!GlobalMarkupOptionsInstances) return;
    GlobalMarkupOptionsInstances.remove(id);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  []); // useEffect doesn't run in SSR, so call emitChange here

  emitChange();
};

var _default = useGlobalMarkupOptions;
exports.default = _default;